module.exports = __webpack_public_path__ + "img/seminar9.a0462cd2.jpg";